export default "__VITE_PUBLIC_ASSET__f9ee4ee7__"